<ng-container *ngIf="_smallNavService.mainAction() && isRecreated">
    <button
        mat-fab
        extended
        *accessControl="{ permissions: permissionList, oneIsTrue: true}"
                [class.bulk-mode-hidden]="isBulkModeActiveOnCalendarRoute()"
                [class.multiselect-hidden]="isMultiSelectActiveOnCalendarRoute()"
        [disabled]="
        (_smallNavService.mainAction()?.callback === 'save' 
        || _smallNavService.mainAction().isSaveAction)
          ? !_pageActionStateService.isFormValid()
          : false
        "
        (click)="actionClicked(_smallNavService.mainAction())"
        
    >
        <mat-icon class="icon">
            {{_smallNavService.mainAction().icon}}
        </mat-icon>
        <span class="label-button">
            {{ getMainActionText() }}
        </span>
    </button>
</ng-container>
<!-- *accessControl="{ permissions: administrationPermissions['edit-details-account']}" -->
